<template>
  <div class="compilation-section__main border-remove" v-if="pageheader!=''">
    <h1 class="compilation-section__title">{{pageheader}}</h1>

    <div class="compilation-section__subtext" v-if="pagetext.length>0">

      <div id="id_readmore" style="max-height: 100px; overflow: hidden" v-html="pagetext"></div>
      <div id="id_readmore_tmp_more" style="visibility: hidden">
        <div style="margin-top:15px" class="read_more">
          <span class="pointer link-lined">{{ $t("message.ReadMore") }}</span>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
  import SeoMix from "./SeoMix";

  export default {
    name      : 'page-header8',
    props: [ 'title' ],
    mixins: [SeoMix],
  }
</script>



// WEBPACK FOOTER //
// src/components/PageHeader8.vue